import api from './authService';

export const transactionService = {
  async getTransactions(params = {}) {
    try {
      const queryParams = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          queryParams.append(key, value);
        }
      });

      const response = await api.get(`/transactions?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch transactions' };
    }
  },

  async getTransaction(id) {
    try {
      const response = await api.get(`/transactions/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch transaction' };
    }
  },

  async getOrganizationTransactions(organizationId, params = {}) {
    try {
      const queryParams = new URLSearchParams(params);
      const response = await api.get(
        `/transactions/organization/${organizationId}?${queryParams.toString()}`
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || {
        message: 'Failed to fetch organization transactions'
      };
    }
  },

  async getStats(params = {}) {
    try {
      const queryParams = new URLSearchParams(params);
      const response = await api.get(
        `/transactions/stats/summary?${queryParams.toString()}`
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || {
        message: 'Failed to fetch transaction statistics'
      };
    }
  },

  async processRefund(transactionId, reason, amount) {
    try {
      const response = await api.post(`/transactions/${transactionId}/refund`, {
        reason,
        amount
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to process refund' };
    }
  },

  async exportTransactions(params = {}) {
    try {
      const queryParams = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          queryParams.append(key, value);
        }
      });

      const response = await api.get(
        `/transactions/export/csv?${queryParams.toString()}`,
        { responseType: 'blob' }
      );

      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `transactions_${Date.now()}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return { success: true };
    } catch (error) {
      throw error.response?.data || { message: 'Failed to export transactions' };
    }
  },

  async downloadInvoice(transactionId, invoiceNumber) {
    try {
      const response = await api.get(`/transactions/${transactionId}/invoice-pdf`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: 'application/pdf' })
      );
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${invoiceNumber || `invoice-${transactionId}`}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      return { success: true };
    } catch (error) {
      throw error.response?.data || { message: 'Failed to download invoice' };
    }
  },

  async syncTransactions() {
    try {
      const response = await api.post('/transactions/sync', {});
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to sync transactions' };
    }
  }
};

export default transactionService;
